/**
 * HomePage.jsx
 * Root page for the QuitPact platform.
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeatureTilesSection from '../components/home/FeatureTilesSection';
import './HomePage.css';

const HomePage = () => {
  return (
    <main className="home-page" aria-label="QuitPact home">

      {/* -- Above-the-fold: heading, value prop, steps, CTA, stats -- */}
      <HeroSection />

      {/* -- Below the fold: "Why use QuitPact" benefit tiles -- */}
      <FeatureTilesSection />

    </main>
  );
};

export default HomePage;
